import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { BsChevronDown } from "react-icons/bs"; //react-icon
import Collapsible from "react-collapsible";
import { Images } from "../../theme";
import { Footer, Header, LoginHeader } from "../../components";
import { GlobalContext } from "../../context/GlobalContext";
import { useTranslation } from "react-i18next";

import "./style.css";

export default () => {
  const getContextItems = useContext(GlobalContext);
  let { user_data, loginData } = getContextItems;

  const { t } = useTranslation();

  useEffect(() => {
    user_data();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {loginData?.id ? <Header /> : <LoginHeader />}
      <div className="container">
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <Link to="/">
              <span className="homeHeading">{t("Home")}</span>
            </Link>
            <span className="arrowStyle">
              {" "}
              <img src={Images.ArrowNew} alt="image" />{" "}
            </span>
            <span className="pageHeading">{t("Privacy_Policy")}</span>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 offset-lg-2 mt-3 mb-3">
            <h1 className="mt-5 poppins term-head text-center">
              {t("Elephant_Please")} {t("Privacy_Policy")}
            </h1>
            <p className="poppins mt-3 text-center">
              {t("Date_Updated")} 27, 2021
            </p>
            <p className="text-center terms-p poppins">
              {t("Main_privicy_descreption_br1")}
              <br /> <br />
              {t("Main_privicy_descreption_br2")}
            </p>
          </div>
        </div>
        <div className="row mb-5">
          <div className="col-lg-12">
            <Collapsible trigger={[t("Privacy_Heading_1"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_1_br1")}
                <br /> <br /> {t("privicy_descreption_1_br2")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_2"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_2")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_3"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_3_br1")} <br /> <br />{" "}
                {t("privicy_descreption_3_br2")} <br /> <br />
                {t("privicy_descreption_3_br3")} <br />
                <br /> {t("privicy_descreption_3_br4")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_4"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_4_br1")}
                <br /> {t("privicy_descreption_4_br2")} <br />
                {t("privicy_descreption_4_br3")}
                <br /> {t("privicy_descreption_4_br4")}
                <br /> {t("privicy_descreption_4_br5")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_5"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_5_br1")} <br />{" "}
                {t("privicy_descreption_5_br2")} <br /> <br />
                {t("privicy_descreption_5_br3")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_6"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_6_br1")} <br /> <br />{" "}
                {t("privicy_descreption_6_br2")} <br />
                <br /> {t("privicy_descreption_6_br3")}
                <br />
                <br /> {t("privicy_descreption_6_br4")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_7"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_7_br1")}
                <br />
                <br /> {t("privicy_descreption_7_br2")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_8"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_8")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_9"), <BsChevronDown />]}>
              <p>
                <br />R{t("privicy_descreption_9_br1")} <br />
                <br /> {t("privicy_descreption_9_br2")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_10"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_10_br1")} <br /> <br />{" "}
                {t("privicy_descreption_10_br2")} <br /> <br />{" "}
                {t("privicy_descreption_10_br3")} <br /> <br />{" "}
                {t("privicy_descreption_10_br4")} <br /> <br />
                {t("privicy_descreption_10_br5")} <br /> <br />{" "}
                {t("privicy_descreption_10_br6")} <br /> <br />{" "}
                {t("privicy_descreption_10_br7")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_11"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_11")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_12"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_12")}
              </p>
            </Collapsible>
            <Collapsible trigger={[t("Privacy_Heading_13"), <BsChevronDown />]}>
              <p>
                <br />
                {t("privicy_descreption_13_br1")}
                <br />
                <br />
                {t("privicy_descreption_13_br2")}
                <br />
                <br /> {t("privicy_descreption_13_br3")}
                <br />
                <br />
                {t("privicy_descreption_13_br4")}
                <br />
                <br />
                {t("privicy_descreption_13_br5")}
              </p>
            </Collapsible>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
